
const freeShippingAmount = 6000;

function updateMissingAmount(amount){
    const cartMissingAmount = document.getElementById('missing-amount');
    cartMissingAmount.innerHTML = `${amount}`;
}

function checkCartProgressBar(){

    const cartProgressBar = document.querySelector('.cart-drawer .cart-progress-bar');
    const cartPriceAmount = parseInt(document.querySelector('.cart-drawer button[type=submit]').dataset.price);
    //console.log(cartPriceAmount);
    const cartProgress = cartProgressBar.querySelector('.progress');

    if(cartPriceAmount>freeShippingAmount){
        cartProgressBar.classList.add('free');
        //console.log('free shipping');
        cartProgress.style.width = `100%`;
    }else{
        const priceDifference = parseFloat((freeShippingAmount-cartPriceAmount)/100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
        updateMissingAmount(priceDifference);
        cartProgressBar.classList.remove('free');
        //console.log('paid shipping');

        const missingAmountRate = cartPriceAmount/freeShippingAmount*100;
        cartProgress.style.width = `${missingAmountRate}%`;
    }
}

setInterval(checkCartProgressBar, 500);